import { Tool } from '../../types';

export const websiteBuildingTools: Tool[] = [
  {
    id: 'webflow',
    name: 'Webflow',
    category: 'Website Building',
    description: 'Professional website builder with advanced design capabilities',
    pricing: ['free', 'medium', 'high'],
    features: ['ease-of-use', 'integrations', 'mobile'],
    bestFor: ['small-business', 'agency'],
    compatibleWith: ['content-creator', 'service-business'],
    goals: ['build-brand', 'improve-marketing'],
    industries: ['creative', 'marketing', 'technology'],
    website: 'https://webflow.com',
    imageUrl: 'https://logo.clearbit.com/webflow.com',
    idealStages: ['launching', 'growing', 'scaling'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'solo'
  },
  {
    id: 'wix',
    name: 'Wix',
    category: 'Website Building',
    description: 'Website builder with drag-and-drop interface',
    pricing: ['free', 'low', 'medium'],
    features: ['ease-of-use', 'mobile', 'integrations'],
    bestFor: ['freelancer', 'small-business'],
    compatibleWith: ['content-creator', 'service-business'],
    goals: ['build-brand', 'improve-marketing'],
    industries: ['creative', 'retail', 'marketing'],
    website: 'https://www.wix.com',
    imageUrl: 'https://logo.clearbit.com/wix.com',
    idealStages: ['launching', 'growing'],
    technicalLevel: ['beginner'],
    minTeamSize: 'solo'
  },
  {
    id: 'wordpress',
    name: 'WordPress',
    category: 'Website Building',
    description: 'Popular content management system and website platform',
    pricing: ['free', 'low', 'medium'],
    features: ['ease-of-use', 'integrations', 'mobile'],
    bestFor: ['small-business', 'content-creator'],
    compatibleWith: ['service-business', 'e-commerce'],
    goals: ['build-brand', 'improve-marketing'],
    industries: ['creative', 'retail', 'marketing'],
    website: 'https://wordpress.org',
    imageUrl: 'https://logo.clearbit.com/wordpress.org',
    idealStages: ['launching', 'growing', 'scaling'],
    technicalLevel: ['intermediate', 'advanced'],
    minTeamSize: 'solo'
  }
];